export default "__VITE_ASSET__oSS8$SYO__"